/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tableHead, jtableHead, totaltableHead } from './tableHead';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { exportAllPDF } from './exportAll';
import { viewPortHeight_380 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

const DisplayDrug = () => {
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [fullScreenView1, setFullScreenView1] = useState(false);
  const [fullScreenView2, setFullScreenView2] = useState(false);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    displayObj: {
      drugCms: getDrugCmsList,
      rebateProgramName: getRebateProgramName,
      quarterFrom: getQuarter,
      drug: getDrugList,
      cms: getCmsList,
    },
  } = useSelector((state) => state?.sharedState?.DrugSummaryReducer);
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const handleFullScreenView1 = () => {
    setFullScreenView1(!fullScreenView1);
  };
  const handleFullScreenView2 = () => {
    setFullScreenView2(!fullScreenView2);
  };
  // pagination
  const [paginationArray, setPaginationArray] = useState([1, 2, 3]);

  let firstInfo = '';
  let thirdInfo = '';

  firstInfo = `Quarter: ${getQuarter}`;
  thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;

  const data1 = getCmsList?.rebateCmsTypeVOList ?? [];
  const data2 = getDrugList?.rebateDrugTypeVO ?? [];
  const data3 = getDrugCmsList?.rebateDrugCmsTypeVO?.drugTypeSourceCd ?? '';
  const claims = [
    'Co-Pay',
    'TPL',
    'Dispensing Fee',
    'Product Reimbursement',
    'Total Reimbursement',
    'Mfg Invoiced Amount	',
    'Net If Collected',
    '% Total Invoiced',
  ];

  let rowData = data3 === 'CMS' ? data1 : data3 === 'DRUG' ? data2 : [];

  const claimsObj = {
    copayAmt: 'Co-Pay',
    tpl: 'TPL',
    dispensingFee: 'Dispensing Fee',
    prodReimbures: 'Product Reimbursement',
    reimbursementAmt: 'Total Reimbursement',
    sumOfAmt: 'Mfg Invoiced Amount',
    netIfCollected: 'Net If Collected',
    // total: '% Total Invoiced',
  };

  const formatdata = (data) => {
    let obj = [...data];
    const mfgInv = data.filter((o) => o.field1 === 'Mfg Invoiced Amount')[0];
    const totalrow = {
      field1: '% Total Invoiced',
      field2: `${Math.abs((mfgInv.field2 / mfgInv.field5) * 100 || 0).toFixed(
        2
      )}%`,
      field3: `${Math.abs((mfgInv.field3 / mfgInv.field5) * 100 || 0).toFixed(
        2
      )}%`,
      field4: `${Math.abs((mfgInv.field4 / mfgInv.field5) * 100 || 0).toFixed(
        2
      )}%`,
      field5: mfgInv?.field5 ? '100.00%' : '0.00%',
    };
    // obj = obj.map((o) => {
    //   o.field2 = `$ ${Math.abs(o.field2).toFixed(2)}`;
    //   o.field3 = `$ ${Math.abs(o.field3).toFixed(2)}`;
    //   o.field4 = `$ ${Math.abs(o.field4).toFixed(2)}`;
    //   o.field5 = `$ ${Math.abs(o.field5).toFixed(2)}`;
    //   return o;
    // });
    return [...obj, totalrow];
  };
  const [tb1data, setTb1Data] = React.useState([]);
  const [tb2data, setTb2Data] = React.useState([]);
  const [tb3data, setTb3Data] = React.useState([]);

  React.useEffect(() => {
    if (getDrugCmsList?.rebateDrugCmsTypeVO?.drugTypeSourceCd) {
      // pharmacy data
      const sPharm = rowData
        .filter((o) => o.drugCatCd === 'S')
        .filter(
          (o) => o.claimCategoryCd !== 'MD' && o.claimCategoryCd !== 'MN'
        );
      const nPharm = rowData
        .filter((o) => o.drugCatCd === 'N')
        .filter(
          (o) => o.claimCategoryCd !== 'MD' && o.claimCategoryCd !== 'MN'
        );
      const iPharm = rowData
        .filter((o) => o.drugCatCd === 'I')
        .filter(
          (o) => o.claimCategoryCd !== 'MD' && o.claimCategoryCd !== 'MN'
        );
      // Jcode data
      const sJcode = rowData
        .filter((o) => o.drugCatCd === 'S')
        .filter(
          (o) => o.claimCategoryCd === 'MD' || o.claimCategoryCd === 'MN'
        );
      const nJcode = rowData
        .filter((o) => o.drugCatCd === 'N')
        .filter(
          (o) => o.claimCategoryCd === 'MD' || o.claimCategoryCd === 'MN'
        );
      const iJcode = rowData
        .filter((o) => o.drugCatCd === 'I')
        .filter(
          (o) => o.claimCategoryCd === 'MD' || o.claimCategoryCd === 'MN'
        );
      let tb1data = [];
      tb1data = Object.keys(claimsObj).map((val) => {
        return {
          field1: claimsObj[val],
          field2:
            val === 'prodReimbures'
              ? sPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                sPharm
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? sPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                sPharm
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : sPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field3:
            val === 'prodReimbures'
              ? nPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                nPharm
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? nPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                nPharm
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : nPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field4:
            val === 'prodReimbures'
              ? iPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                iPharm
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? iPharm
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                iPharm
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : iPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field5: 0,
          //   sPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0) +
          //   nPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0) +
          //   iPharm.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
        };
      });

      tb1data = tb1data.map((obj) => {
        let val = { ...obj };
        val.field5 = obj.field2 + obj.field3 + obj.field4;
        return val;
      });
      let tb2data = [];
      tb2data = Object.keys(claimsObj).map((val) => {
        return {
          field1: claimsObj[val],
          field2:
            val === 'prodReimbures'
              ? sJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                sJcode
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? sJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                sJcode
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : sJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field3:
            val === 'prodReimbures'
              ? nJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                nJcode
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? nJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                nJcode
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : nJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field4:
            val === 'prodReimbures'
              ? iJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                iJcode
                  .map((o) => o.dispensingFee)
                  .reduce((acc, curr) => acc + curr, 0)
              : val === 'netIfCollected'
              ? iJcode
                  .map((o) => o.reimbursementAmt)
                  .reduce((acc, curr) => acc + curr, 0) -
                iJcode
                  .map((o) => o.sumOfAmt)
                  .reduce((acc, curr) => acc + curr, 0)
              : iJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
          field5: 0,
          //   sJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0) +
          //   nJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0) +
          //   iJcode.map((o) => o[val]).reduce((acc, curr) => acc + curr, 0),
        };
      });

      tb2data = tb2data.map((obj) => {
        let val = { ...obj };
        val.field5 = obj.field2 + obj.field3 + obj.field4;
        return val;
      });

      let tb3data = [];
      for (let i = 0; i < tb1data.length; i++) {
        let value = {
          field1: tb1data[i].field1,
          field2: tb1data[i].field2 + tb2data[i].field2,
          field3: tb1data[i].field3 + tb2data[i].field3,
          field4: tb1data[i].field4 + tb2data[i].field4,
          field5: tb1data[i].field5 + tb2data[i].field5,
        };
        tb3data.push(value);
      }
      // tb1data = formatdata(tb1data);
      // tb2data = formatdata(tb2data);
      // tb3data = formatdata(tb3data);
      setTb1Data(formatdata(tb1data));
      setTb2Data(formatdata(tb2data));
      setTb3Data(formatdata(tb3data));
    }
  }, []);
  // pharmacy
  // brand
  // let pBCopay = 0;
  // let pBtpl = 0;
  // let pBdispensingFee = 0;
  // let pBreimbursementAmt = 0;
  // let pBMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd != 'MD' ||
  //       rowData[i].claimCategoryCd != 'MN') &&
  //     rowData[i].drugCatCd == 'S'
  //   ) {
  //     pBCopay += rowData[i].copayAmt;
  //     pBtpl += rowData[i].tpl;
  //     pBdispensingFee += rowData[i].dispensingFee;
  //     pBreimbursementAmt += rowData[i].reimbursementAmt;
  //     pBMfg += rowData[i].sumOfAmt;
  //   }
  // }

  // let pBTtlRem = pBreimbursementAmt - pBdispensingFee; //pBdispensingFee + pBreimbursementAmt;
  // let pBNet = pBreimbursementAmt - pBMfg;
  // // generic
  // let pGCopay = 0;
  // let pGtpl = 0;
  // let pGdispensingFee = 0;
  // let pGreimbursementAmt = 0;
  // let pGMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd != 'MD' ||
  //       rowData[i].claimCategoryCd != 'MN') &&
  //     rowData[i].drugCatCd == 'I'
  //   ) {
  //     pGCopay += rowData[i].copayAmt;
  //     pGtpl += rowData[i].tpl;
  //     pGdispensingFee += rowData[i].dispensingFee;
  //     pGreimbursementAmt += rowData[i].reimbursementAmt;
  //     pGMfg += rowData[i].sumOfAmt;
  //   }
  // }
  // let pGTtlRem = pGreimbursementAmt - pGdispensingFee; //pGdispensingFee + pGreimbursementAmt;
  // let pGNet = pGreimbursementAmt - pGMfg;

  // // Multisource
  // let pMCopay = 0;
  // let pMtpl = 0;
  // let pMdispensingFee = 0;
  // let pMreimbursementAmt = 0;
  // let pMMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd != 'MD' ||
  //       rowData[i].claimCategoryCd != 'MN') &&
  //     rowData[i].drugCatCd == 'N'
  //   ) {
  //     pMCopay += rowData[i].copayAmt;
  //     pMtpl += rowData[i].tpl;
  //     pMdispensingFee += rowData[i].dispensingFee;
  //     pMreimbursementAmt += rowData[i].reimbursementAmt;
  //     pMMfg += rowData[i].sumOfAmt;
  //   }
  // }
  // let pMTtlRem = pMreimbursementAmt - pMdispensingFee; //pMdispensingFee + pMreimbursementAmt;
  // let pMNet = pMreimbursementAmt - pMMfg;

  // let pTCopay = pBCopay + pGCopay + pMCopay;
  // let pTtpl = pBtpl + pGtpl + pMtpl;
  // let pTdispensingFee = pBdispensingFee + pGdispensingFee + pMdispensingFee;
  // let pTreimbursementAmt =
  //   pBreimbursementAmt + pGreimbursementAmt + pMreimbursementAmt;
  // let pTTtlRem = pBTtlRem + pGTtlRem + pMTtlRem;
  // let pTMfg = pBMfg + pGMfg + pMMfg;
  // let pTNet = pBNet + pGNet + pMNet;

  // // percentage
  // let perB = (pBMfg / pTMfg) * 100;
  // let perG = (pGMfg / pTMfg) * 100;
  // let perM = (pMMfg / pTMfg) * 100;
  // let perT = perB + perG + perM;

  // // jcode
  // // Brand
  // let jBCopay = 0;
  // let jBtpl = 0;
  // let jBdispensingFee = 0;
  // let jBreimbursementAmt = 0;
  // let jBMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd === 'MD' ||
  //       rowData[i].claimCategoryCd === 'MN') &&
  //     rowData[i].drugCatCd == 'S'
  //   ) {
  //     jBCopay += rowData[i].copayAmt;
  //     jBtpl += rowData[i].tpl;
  //     jBdispensingFee += rowData[i].dispensingFee;
  //     jBreimbursementAmt += rowData[i].reimbursementAmt;
  //     jBMfg += rowData[i].sumOfAmt;
  //   }
  // }
  // let jBTtlRem = jBreimbursementAmt - jBdispensingFee; //jBdispensingFee + jBreimbursementAmt;
  // let jBNet = jBreimbursementAmt - jBMfg;

  // // generic
  // let jGCopay = 0;
  // let jGtpl = 0;
  // let jGdispensingFee = 0;
  // let jGreimbursementAmt = 0;
  // let jGMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd === 'MD' ||
  //       rowData[i].claimCategoryCd === 'MN') &&
  //     rowData[i].drugCatCd == 'I'
  //   ) {
  //     jGCopay += rowData[i].copayAmt;
  //     jGtpl += rowData[i].tpl;
  //     jGdispensingFee += rowData[i].dispensingFee;
  //     jGreimbursementAmt += rowData[i].reimbursementAmt;
  //     jGMfg += rowData[i].sumOfAmt;
  //   }
  // }
  // let jGTtlRem = jGreimbursementAmt - jGdispensingFee; //jGdispensingFee + jGreimbursementAmt;
  // let jGNet = jGreimbursementAmt - jGMfg;

  // // multisource
  // let jMCopay = 0;
  // let jMtpl = 0;
  // let jMdispensingFee = 0;
  // let jMreimbursementAmt = 0;
  // let jMMfg = 0;
  // for (let i = 0; i < rowData.length; i += 1) {
  //   if (
  //     (rowData[i].claimCategoryCd === 'MD' ||
  //       rowData[i].claimCategoryCd === 'MN') &&
  //     rowData[i].drugCatCd == 'N'
  //   ) {
  //     jMCopay += rowData[i].copayAmt;
  //     jMtpl += rowData[i].tpl;
  //     jMdispensingFee += rowData[i].dispensingFee;
  //     jMreimbursementAmt += rowData[i].reimbursementAmt;
  //     jMMfg += rowData[i].sumOfAmt;
  //   }
  // }
  // let jMTtlRem = jMreimbursementAmt - jMdispensingFee; //jMdispensingFee + jMreimbursementAmt;
  // let jMNet = jMreimbursementAmt - jMMfg;

  // let jTCopay = jBCopay + jGCopay + jMCopay;
  // let jTtpl = jBtpl + jGtpl + jMtpl;
  // let jTdispensingFee = jBdispensingFee + jGdispensingFee + jMdispensingFee;
  // let jTreimbursementAmt =
  //   jBreimbursementAmt + jGreimbursementAmt + jMreimbursementAmt;
  // let jTTtlRem = jBTtlRem + jGTtlRem + jMTtlRem;
  // let jTMfg = jBMfg + jGMfg + jMMfg;
  // let jTNet = jBNet + jGNet + jMNet;

  // // percentage
  // let jperB = (jBMfg / jTMfg) * 100;
  // let jperG = (jGMfg / jTMfg) * 100;
  // let jperM = (jMMfg / jTMfg) * 100;
  // let jperT = jperB + jperG + jperM;

  // // Total
  // // brand
  // let tBCopay = pBCopay + jBCopay;
  // let tBtpl = pBtpl + jBtpl;
  // let tBdispensingFee = pBdispensingFee + jBdispensingFee;
  // let tBreimbursementAmt = pBreimbursementAmt + jBreimbursementAmt;
  // let tBTtlRem = pBTtlRem + jBTtlRem;
  // let tBMfg = pBMfg + jBMfg;
  // let tBNet = pBNet + jBNet;

  // // generic

  // let tGCopay = pGCopay + jGCopay;
  // let tGtpl = pGtpl + jGtpl;
  // let tGdispensingFee = pGdispensingFee + jGdispensingFee;
  // let tGreimbursementAmt = pGreimbursementAmt + jGreimbursementAmt;
  // let tGTtlRem = pGTtlRem + jGTtlRem;
  // let tGMfg = pGMfg + jGMfg;
  // let tGNet = pGNet + jGNet;

  // // multisource
  // let tMCopay = pMCopay + jMCopay;
  // let tMtpl = pMtpl + jMtpl;
  // let tMdispensingFee = pMdispensingFee + jMdispensingFee;
  // let tMreimbursementAmt = pMreimbursementAmt + jMreimbursementAmt;
  // let tMTtlRem = pMTtlRem + jMTtlRem;
  // let tMMfg = pMMfg + jMMfg;
  // let tMNet = pMNet + jMNet;

  // // Total
  // let tTCopay = pTCopay + jTCopay;
  // let tTtpl = pTtpl + jTtpl;
  // let tTdispensingFee = pTdispensingFee + jTdispensingFee;
  // let tTreimbursementAmt = pTreimbursementAmt + jTreimbursementAmt;
  // let tTTtlRem = pTTtlRem + jTTtlRem;
  // let tTMfg = pTMfg + jTMfg;
  // let tTNet = pTNet + jTNet;

  // // percentage
  // let tperB = (tBMfg / tTMfg) * 100;
  // let tperG = (tGMfg / tTMfg) * 100;
  // let tperM = (tMMfg / tTMfg) * 100;
  // let tperT = tperB + tperG + tperM;
  // // formatting values
  // // pharmacy
  // // Brand
  // pBCopay = parseFloat(pBCopay);
  // pBtpl = parseFloat(pBtpl);
  // pBdispensingFee = parseFloat(pBdispensingFee);

  // pBreimbursementAmt = parseFloat(pBreimbursementAmt);

  // pBTtlRem = parseFloat(pBTtlRem);

  // pBMfg = parseFloat(pBMfg);

  // pBNet = parseFloat(pBNet);

  // perB = perB ? `${perB.toFixed(2)}%` : '0.00%';
  // // pGeneric
  // pGCopay = parseFloat(pGCopay);

  // pGtpl = parseFloat(pGtpl);

  // pGdispensingFee = parseFloat(pGdispensingFee);

  // pGreimbursementAmt = parseFloat(pGreimbursementAmt);

  // pGTtlRem = parseFloat(pGTtlRem);

  // pGMfg = parseFloat(pGMfg);

  // pGNet = parseFloat(pGNet);

  // perG = perG ? `${perG.toFixed(2)}%` : '0.00%';
  // // MultiSource
  // pMCopay = parseFloat(pMCopay);

  // pMtpl = parseFloat(pMtpl);

  // pMdispensingFee = parseFloat(pMdispensingFee);

  // pMreimbursementAmt = parseFloat(pMreimbursementAmt);

  // pMTtlRem = parseFloat(pMTtlRem);

  // pMMfg = parseFloat(pMMfg);

  // pMNet = parseFloat(pMNet);

  // perM = perM ? `${perM.toFixed(2)}%` : '0.00%';
  // // Total
  // pTCopay = parseFloat(pTCopay);

  // pTtpl = parseFloat(pTtpl);

  // pTdispensingFee = parseFloat(pTdispensingFee);

  // pTreimbursementAmt = parseFloat(pTreimbursementAmt);

  // pTTtlRem = parseFloat(pTTtlRem);

  // pTMfg = parseFloat(pTMfg);

  // pTNet = parseFloat(pTNet);

  // perT = perT ? `${perT.toFixed(2)}%` : '0.00%';
  // // JCode
  // // Brand
  // jBCopay = parseFloat(jBCopay);

  // jBtpl = parseFloat(jBtpl);

  // jBdispensingFee = parseFloat(jBdispensingFee);

  // jBreimbursementAmt = parseFloat(jBreimbursementAmt);

  // jBTtlRem = parseFloat(jBTtlRem);

  // jBMfg = parseFloat(jBMfg);

  // jBNet = parseFloat(jBNet);

  // jperB = jperB ? `${jperB.toFixed(2)}%` : '0.00%';
  // // Generic
  // jGCopay = parseFloat(jGCopay);

  // jGtpl = parseFloat(jGtpl);

  // jGdispensingFee = parseFloat(jGdispensingFee);

  // jGreimbursementAmt = parseFloat(jGreimbursementAmt);

  // jGTtlRem = parseFloat(jGTtlRem);

  // jGMfg = parseFloat(jGMfg);

  // jGNet = parseFloat(jGNet);

  // jperG = jperG ? `${jperG.toFixed(2)}%` : '0.00%';
  // // MultiSource
  // jMCopay = parseFloat(jMCopay);

  // jMtpl = parseFloat(jMtpl);

  // jMdispensingFee = parseFloat(jMdispensingFee);

  // jMreimbursementAmt = parseFloat(jMreimbursementAmt);

  // jMTtlRem = parseFloat(jMTtlRem);

  // jMMfg = parseFloat(jMMfg);

  // jMNet = parseFloat(jMNet);

  // jperM = jperM ? `${jperM.toFixed(2)}%` : '0.00%';
  // // Total
  // jTCopay = parseFloat(jTCopay);

  // jTtpl = parseFloat(jTtpl);

  // jTdispensingFee = parseFloat(jTdispensingFee);

  // jTreimbursementAmt = parseFloat(jTreimbursementAmt);

  // jTTtlRem = parseFloat(jTTtlRem);

  // jTMfg = parseFloat(jTMfg);

  // jTNet = parseFloat(jTNet);

  // jperT = jperT ? `${jperT.toFixed(2)}%` : '0.00%';
  // // GrandTotal
  // // Brand
  // tBCopay = parseFloat(tBCopay);

  // tBtpl = parseFloat(tBtpl);

  // tBdispensingFee = parseFloat(tBdispensingFee);

  // tBreimbursementAmt = parseFloat(tBreimbursementAmt);

  // tBTtlRem = parseFloat(tBTtlRem);

  // tBMfg = parseFloat(tBMfg);

  // tBNet = parseFloat(tBNet);

  // tperB = tperB ? `${tperB.toFixed(2)}%` : '0.00%';
  // // Generic
  // tGCopay = parseFloat(tGCopay);

  // tGtpl = parseFloat(tGtpl);

  // tGdispensingFee = parseFloat(tGdispensingFee);

  // tGreimbursementAmt = parseFloat(tGreimbursementAmt);

  // tGTtlRem = parseFloat(tGTtlRem);

  // tGMfg = parseFloat(tGMfg);

  // tGNet = parseFloat(tGNet);

  // tperG = tperG ? `${tperG.toFixed(2)}%` : '0.00%';
  // // MultiSorce
  // tMCopay = parseFloat(tMCopay);

  // tMtpl = parseFloat(tMtpl);

  // tMdispensingFee = parseFloat(tMdispensingFee);

  // tMreimbursementAmt = parseFloat(tMreimbursementAmt);

  // tMTtlRem = parseFloat(tMTtlRem);

  // tMMfg = parseFloat(tMMfg);

  // tMNet = parseFloat(tMNet);

  // tperM = tperM ? `${tperM.toFixed(2)}%` : '0.00%';
  // // Total
  // tTCopay = parseFloat(tTCopay);

  // tTtpl = parseFloat(tTtpl);

  // tTdispensingFee = parseFloat(tTdispensingFee);

  // tTreimbursementAmt = parseFloat(tTreimbursementAmt);

  // tTTtlRem = parseFloat(tTTtlRem);

  // tTMfg = parseFloat(tTMfg);

  // tTNet = parseFloat(tTNet);

  // tperT = tperT ? `${tperT.toFixed(2)}%` : '0.00%';
  // // pharmacy array
  // const pBrand = [
  //   pBCopay,
  //   pBtpl,
  //   pBdispensingFee,
  //   pBTtlRem,
  //   pBreimbursementAmt,
  //   pBMfg,
  //   pBNet,
  //   perB,
  // ];
  // const pGeneric = [
  //   pGCopay,
  //   pGtpl,
  //   pGdispensingFee,
  //   pGTtlRem,
  //   pGreimbursementAmt,
  //   pGMfg,
  //   pGNet,
  //   perG,
  // ];
  // const pMulti = [
  //   pMCopay,
  //   pMtpl,
  //   pMdispensingFee,
  //   pMTtlRem,
  //   pMreimbursementAmt,
  //   pMMfg,
  //   pMNet,
  //   perM,
  // ];
  // const pTotal = [
  //   pTCopay,
  //   pTtpl,
  //   pTdispensingFee,
  //   pTTtlRem,
  //   pTreimbursementAmt,
  //   pTMfg,
  //   pTNet,
  //   perT,
  // ];

  // const pharmacy = claims.map((item, index) => {
  //   return {
  //     field1: item,
  //     field2: pBrand[index],
  //     field3: pGeneric[index],
  //     field4: pMulti[index],
  //     field5: pTotal[index],
  //   };
  // });
  // // jcode array
  // const jBrand = [
  //   jBCopay,
  //   jBtpl,
  //   jBdispensingFee,
  //   jBTtlRem,
  //   jBreimbursementAmt,
  //   jBMfg,
  //   jBNet,
  //   jperB,
  // ];
  // const jGeneric = [
  //   jGCopay,
  //   jGtpl,
  //   jGdispensingFee,
  //   jGTtlRem,
  //   jGreimbursementAmt,
  //   jGMfg,
  //   jGNet,
  //   jperG,
  // ];

  // const jMulti = [
  //   jMCopay,
  //   jMtpl,
  //   jMdispensingFee,
  //   jMTtlRem,
  //   jMreimbursementAmt,
  //   jMMfg,
  //   jMNet,
  //   jperM,
  // ];
  // const jTotal = [
  //   jTCopay,
  //   jTtpl,
  //   jTdispensingFee,
  //   jTTtlRem,
  //   jTreimbursementAmt,
  //   jTMfg,
  //   jTNet,
  //   jperT,
  // ];

  // const jcode = claims.map((item, index) => {
  //   return {
  //     field1: item,
  //     field2: jBrand[index],
  //     field3: jGeneric[index],
  //     field4: jMulti[index],
  //     field5: jTotal[index],
  //   };
  // });
  // // GrandTotal array
  // const tBrand = [
  //   tBCopay,
  //   tBtpl,
  //   tBdispensingFee,
  //   tBTtlRem,
  //   tBreimbursementAmt,
  //   tBMfg,
  //   tBNet,
  //   tperB,
  // ];
  // const tGeneric = [
  //   tGCopay,
  //   tGtpl,
  //   tGdispensingFee,
  //   tGTtlRem,
  //   tGreimbursementAmt,
  //   tGMfg,
  //   tGNet,
  //   tperG,
  // ];
  // const tMulti = [
  //   tMCopay,
  //   tMtpl,
  //   tMdispensingFee,
  //   tMTtlRem,
  //   tMreimbursementAmt,
  //   tMMfg,
  //   tMNet,
  //   tperM,
  // ];
  // const tTotal = [
  //   tTCopay,
  //   tTtpl,
  //   tTdispensingFee,
  //   tTTtlRem,
  //   tTreimbursementAmt,
  //   tTMfg,
  //   tTNet,
  //   tperT,
  // ];
  // const grandTotal = claims.map((item, index) => {
  //   return {
  //     field1: item,
  //     field2: tBrand[index],
  //     field3: tGeneric[index],
  //     field4: tMulti[index],
  //     field5: tTotal[index],
  //   };
  // });
  const getDataForExport = () => {
    const pharmacyData = tb1data.map((obj) => {
      const updatedObj = {};
      for (let i = 0; i < tableHead.length; i += 1) {
        if (i === 0) {
          updatedObj[tableHead[i].headerName] = obj[tableHead[i].field];
        } else {
          updatedObj[tableHead[i].headerName] =
            typeof obj[tableHead[i].field] === 'string' &&
            obj[tableHead[i].field]?.includes('%')
              ? obj[tableHead[i].field]
              : `$ ${obj[tableHead[i].field]?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
        }
      }
      return updatedObj;
    });

    const JCodeHead = {};
    const jcodeData = tb2data.map((obj) => {
      const updatedObj = {};
      for (let i = 0; i < tableHead.length; i += 1) {
        if (i === 0) {
          updatedObj[tableHead[i].headerName] = obj[tableHead[i].field];
          JCodeHead[tableHead[i].headerName] = jtableHead[i].headerName;
        } else {
          updatedObj[tableHead[i].headerName] =
            typeof obj[tableHead[i].field] === 'string' &&
            obj[tableHead[i].field]?.includes('%')
              ? obj[tableHead[i].field]
              : `$ ${obj[tableHead[i].field]?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
        }
      }
      return updatedObj;
    });
    const totalHead = {};
    const grandTotalData = tb3data.map((obj) => {
      const updatedObj = {};
      for (let i = 0; i < tableHead.length; i += 1) {
        if (i === 0) {
          updatedObj[tableHead[i].headerName] = obj[tableHead[i].field];
          totalHead[tableHead[i].headerName] = totaltableHead[i].headerName;
        } else {
          updatedObj[tableHead[i].headerName] =
            typeof obj[tableHead[i].field] === 'string' &&
            obj[tableHead[i].field]?.includes('%')
              ? obj[tableHead[i].field]
              : `$ ${obj[tableHead[i].field]?.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
        }
      }
      return updatedObj;
    });
    return {
      pharmacyData,

      JCodeHead,
      jcodeData,

      totalHead,
      grandTotalData,
    };
  };
  const exportAllToXlsx = () => {
    const { pharmacyData, JCodeHead, jcodeData, totalHead, grandTotalData } =
      getDataForExport();
    const jsonData = [
      ...pharmacyData,
      {},
      JCodeHead,
      ...jcodeData,
      {},
      totalHead,
      ...grandTotalData,
    ];
    return {
      jsonData,
      boldRows: [1, 11, 21],
    };
  };
  const exportAllTpPDF = (name) => {
    const { pharmacyData, JCodeHead, jcodeData, totalHead, grandTotalData } =
      getDataForExport();
    const header = {
      reportName: 'Drug Type Summary Report',
      fileName: name,
    };
    const options = {
      info: { thirdInfo, firstInfo },
      titleName: 'Type  ',
    };
    const paginationArr = [];
    const widths = [];
    const allData = {
      'Pharmacy Claims Section': pharmacyData,
      'JCode Claims Section': jcodeData,
      'Grand Total Section': grandTotalData,
    };

    const updatedTable = tableHead.map((item) => {
      return {
        ...item,
        field: item.headerName,
      };
    });

    exportAllPDF(
      header,
      allData,
      updatedTable,
      userDefaults,
      options,
      paginationArr,
      widths,
      logInUser
    );
  };
  return (
    <>
      <div className="tBillPanel custom-check tabs-container">
        <div className="panel tBillPanel-space devider-line pb-0">
          <CustomSeparator
            parent1="Summary Reports"
            parent2="Display Drug Type Summary"
          />
          <Spinner load={spinnerLoader} />
          {!fullScreenView && (
            <>
              <div className="row mb-5" />
              <div className="panel custom-fieldset">
                <div className="custom-check">
                  <div className="form-wrapper">
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Rebate_Program"
                          label="Rebate Program"
                          fullWidth
                          required
                          placeholder=""
                          inputProps={{ id: 'Rebate_Program' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={`${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Quarter"
                          label="Quarter"
                          fullWidth
                          required
                          inputProps={{ id: 'Quarter' }}
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={getQuarter}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              ref={gridRef}
              rowSelection="single"
              data-testid="onEditingStopped"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_380}
              rowData={
                tb1data
                // pharmacy?.length > 0
                //   ? pharmacy.sort((a, b) => a.field1 - b.field1)
                //   : []
              }
              columnDefs={tableHead}
              exportFile
              animateRows
              sideBar={false}
              fileName="DrugTypeSummary"
              reportName="Drug Type Summary Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              noGlobalSort
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ firstInfo, thirdInfo }}
              exportAllToXlsx={exportAllToXlsx}
              exportAllToCSV={exportAllToXlsx}
              exportAllTpPDF={exportAllTpPDF}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />

            <TableGrid
              ref={gridRef}
              data-testid="drug-type"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView1}
              handleFullScreenViewClick={handleFullScreenView1}
              gridHeight={fullScreenView1 ? '70vh' : viewPortHeight_380}
              rowData={
                tb2data
                // jcode?.length > 0
                //   ? jcode.sort((a, b) => a.field1 - b.field1)
                //   : []
              }
              columnDefs={jtableHead}
              noGlobalSort
              exportFile
              animateRows
              sideBar={false}
              fileName="DrugTypeSummary"
              reportName="Drug Type Summary Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ firstInfo, thirdInfo }}
              exportAllToXlsx={exportAllToXlsx}
              exportAllToCSV={exportAllToXlsx}
              exportAllTpPDF={exportAllTpPDF}
            />
            <TableGrid
              ref={gridRef}
              data-testid="drug-type1"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView2}
              handleFullScreenViewClick={handleFullScreenView2}
              gridHeight={fullScreenView2 ? '70vh' : viewPortHeight_380}
              rowData={
                tb3data
                // grandTotal?.length > 0
                //   ? grandTotal.sort((a, b) => a.field1 - b.field1)
                //   : []
              }
              columnDefs={totaltableHead}
              exportFile
              animateRows
              noGlobalSort
              sideBar={false}
              fileName="DrugTypeSummary"
              reportName="Drug Type Summary Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ firstInfo, thirdInfo }}
              exportAllToXlsx={exportAllToXlsx}
              exportAllToCSV={exportAllToXlsx}
              exportAllTpPDF={exportAllTpPDF}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayDrug;
